import React, { useCallback, useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import weui from "weui.js";
import { payService } from "../../services";
import { refreshRedux } from "../../stores";
import { getAxiosError } from "../../utils";

export const WechatLogin = props => {
  const navigate = useNavigate();
  const [qs, setQs] = useSearchParams();
  const code = useMemo(() => qs.get("code"), [qs]);
  const returnUrl = useMemo(() => qs.get("state"), [qs]);
  
  const login = useCallback(async () => {
    const loading = weui.loading("登陆中");
    try {
      await payService.wechatLogin(code);
      await refreshRedux();
    } catch (err) {
      weui.topTips(getAxiosError(err));
    } finally {
      navigate(returnUrl, { replace: true });
      loading.hide();
    }
  }, [code, navigate, returnUrl]);

  useEffect(() => {
    login();
  }, [login]);

  return <div></div>;
};
